import { Grid } from "@material-ui/core"
import { Form, FormikProvider, useFormik } from "formik"
import * as Yup from "yup"
import { toast } from "react-toastify"
import { useUpdateSubAdmin } from "../../services/mutations"
import NCModal from "../../shared/NCModal"
import FormField from "../FormField"
import NCButton from "../../shared/NCButton"
import { useQueryClient } from "react-query"
import NCLoader from "../../shared/NCLoader"
import NCAddress from "../../shared/NCAddress"
import { useTranslation } from "react-i18next"

const EditSubAdminModal = ({
  subAdminId,
  modalState = false,
  handleClose,
  data = {}
}) => {
  const queryClient = useQueryClient()
  const { t } = useTranslation();
  const updateAdminApi = useUpdateSubAdmin()
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      address: data.address || "",
      latitude: data?.latitude || "",
      longitude: data?.longitude || "",
    },
    validationSchema: Yup.object().shape({}),
    enableReinitialize: true,
    onSubmit(values) {
      if(values.address == undefined){
        toast.error(t("subadmin.error.address_required"));
        return;
      }
      updateAdminApi.mutate(
        { ...values, id: subAdminId },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(["getSubAdminDetail"])
            queryClient.invalidateQueries(["getSubAdminAuditLog"])
            toast.success(t("subadmin.school_detail_edited"))
            handleClose()
          }
        }
      )
    }
  })
  const companyModal = (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormField
              label={t("common.name")}
              name={"name"}
              required={true}
              error={formik?.errors?.name}
            />
          </Grid>
          <Grid item xs={6}>
            <FormField
              as={NCAddress}
              label={t("common.address")}
              name={"address"}
              onChange={e => {
                formik.setFieldValue("longitude", e?.geometry?.longitude);
                formik.setFieldValue("latitude", e?.geometry?.latitude);
                formik.setFieldValue("address", e?.name);
              }}
              error={formik?.errors?.address}
            />
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  )
  return (
    <>
      <NCModal
        open={modalState}
        title={t("subadmin.edit_subadmin_school")}
        text={companyModal}
        onClose={() => handleClose()}
        submitButton={
          <NCButton
            variant="contained"
            color="primary"
            disableElevation
            onClick={formik.handleSubmit}
            style={{ width: "auto" }}
          >
            {t("common.update")}
          </NCButton>
        }
      />
      {updateAdminApi.isLoading && <NCLoader open={true} />}
    </>
  )
}

export default EditSubAdminModal
